type GetUniqueId = (factor?: string | number) => string

const getUniqueId: GetUniqueId = () => `${Math.random()}`.split('.').pop()!

export default getUniqueId
